import styled from 'styled-components'

import { BodyText } from '@/ui/atoms/body-text'
import { Button } from '@/ui/atoms/button'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const CookieBannerContent = styled.div(
  ({ theme }) => `
    align-items: center;
    background-color: ${theme.colors.white};
    bottom: 0;
    display: flex;
    flex-direction: column;
    padding: ${theme.spacing.default};
    position: fixed;

  ${MEDIA_QUERIES(theme).medium} {
      flex-direction: row;
      padding: ${theme.spacing.husky} 8rem;
  }
`
)

export const CookieBannerDescription = styled(BodyText)(
  ({ theme }) => `
  padding: ${theme.spacing.default} 0;
`
)

// This is the purple button labelled "Close"
export const CookieBannerCloseButton = styled(Button)(
  ({ theme }) => `
    width: 100%;
  ${MEDIA_QUERIES(theme).medium} {
      margin-left: 6.4rem;
      max-width: 20rem;
  }
`
)

export const CookieBannerBackgroundOverlay = styled.div(
  ({ theme }) => `
    background-color: ${theme.colors.grey.dark1};
    height: 100%;
    opacity: 0.5;
    position: fixed;
    top: 0px;
    width: 100%;
  `
)
